"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-table", {
    attrs: {
      data: _vm.tableData,
      "header-cell-style": {
        backgroundColor: "#f0f4ff",
        fontWeight: "bold !important"
      },
      border: "",
      stripe: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "title",
      label: _vm.tableName,
      width: "200px",
      align: "center"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "data1",
      label: "借款次数",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.data1 != -1 ? _c("div", {
          staticStyle: {
            color: "red"
          }
        }, [_vm._v(_vm._s(scope.row.data1))]) : _c("div")];
      }
    }])
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "data2",
      label: "借款机构数",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.data2 != -1 ? _c("div", {
          staticStyle: {
            color: "red"
          }
        }, [_vm._v(_vm._s(scope.row.data2))]) : _c("div")];
      }
    }])
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "data3",
      label: "借款等级",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.data3 != -1 ? _c("div", {
          staticStyle: {
            color: "red"
          }
        }, [_vm._v(_vm._s(scope.row.data3))]) : _c("div")];
      }
    }])
  })], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;